import { render } from "./GotradeLive.vue?vue&type=template&id=df41f8a4"
import script from "./GotradeLive.vue?vue&type=script&lang=js"
export * from "./GotradeLive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__